import { ActionStepStatus } from 'constants/aiChat';

export const resolveActionStepDescription = (status, summary, errorMessage) => {
  if (status === ActionStepStatus.ERROR) {
    return errorMessage;
  }

  if (status === ActionStepStatus.CANCELLED) {
    return summary ?? 'Cancelled';
  }

  return summary;
};

export const formatActionStepContentCopyText = contentProps => {
  const { label, status, summary, errorMessage } = contentProps;
  const statusLabel = status ?? '';
  const trailing = resolveActionStepDescription(status, summary, errorMessage);

  return trailing ? `${label} (${statusLabel}): ${trailing}` : `${label} (${statusLabel})`;
};
